module.exports = __webpack_public_path__ + "img/zk-icon-operation-plan2.e32ede23.svg";